import { render, staticRenderFns } from "./lunb.vue?vue&type=template&id=8045d5c0"
import script from "./lunb.vue?vue&type=script&lang=js"
export * from "./lunb.vue?vue&type=script&lang=js"
import style0 from "./lunb.vue?vue&type=style&index=0&id=8045d5c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports